module.exports = __webpack_public_path__ + "img/jey.e0932aed.svg";